import NotFoundView from "./NotFound";

export default NotFoundView;
